import React from 'react';

export default function SortableTh({ col, label, sortCol, sortDir, onSort, className, align }) {
  const isActive = sortCol === col;
  return (
    <th
      className={className}
      style={{ cursor: 'pointer', userSelect: 'none', textAlign: align }}
      onClick={() => onSort(col)}
    >
      {label}
      <span className={`sort-arrow${isActive ? ' active' : ''}`}>
        {isActive ? (sortDir === 'asc' ? '↑' : '↓') : '↕'}
      </span>
    </th>
  );
}
